<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 m-0">
        <div class="p-2" [ngClass.xl]="'d-flex justify-content-between'" [ngClass.md]="'d-flex justify-content-between'">
          <div class="p-0" [ngClass.sm]="'col-12'">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchDomain()" />
          </div>
          <div [ngClass.sm]="'col-12 text-right mt-1 pr-0'">
            <a class="btn btn-outline-primary text-primary" (click)="modalOpen(addNewDomain, null)" *ngIf="_authenticationService.hasCapability('create_workdomain')">{{ "ADD" | translate }}</a>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 60 : 80"
          [footerHeight]="50"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rows]="filteredDomain"
        >
          <ngx-datatable-column [name]="'MENU.SINGLE_DOMAIN' | translate" prop="name" width="900" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                {{ row.name }}
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <button class="bg-transparent border-0 text-secondary pr-1">
                  <a (click)="modalOpen(editDomainModal, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left" *ngIf="_authenticationService.hasCapability('edit_workdomain')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </a>
                </button>
                <button
                  class="bg-transparent border-0 text-danger remove-item"
                  (click)="delete(row)"
                  [ngbTooltip]="'DELETE' | translate"
                  placement="left"
                  *ngIf="_authenticationService.hasCapability('delete_workdomain')"
                >
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'MENU.SINGLE_DOMAIN' | translate" prop="name" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12 d-flex align-items-center justify-content-between">
                  <div class="text-break-line-1">
                    {{ row.name }}
                  </div>
                  <div>
                    <button class="bg-transparent border-0 text-secondary pr-1">
                      <a (click)="modalOpen(editDomainModal, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" *ngIf="_authenticationService.hasCapability('edit_workdomain')">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </a>
                    </button>
                    <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="_authenticationService.hasCapability('delete_workdomain')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal ADD -->
<ng-template #addNewDomain let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.INSERT_DOMAIN" | translate }}</h3>
    <label [for]="'new_domain'">{{ "DOMAIN" | translate }}<sup class="text-danger">*</sup></label>
    <input name="new_domain" [(ngModel)]="new_domain" type="text" [id]="new_domain" class="form-control" />
    <div class="font-error" *ngIf="showModalError && (!new_domain || new_domain.length < 1)">{{ "ERRORS.FIELD_DOMAIN" | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="addDomain()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "ERRORS.INSERT" | translate }}
    </button>
  </div>
</ng-template>

<!-- Modal EDIT -->
<ng-template #editDomainModal let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.EDIT_DOMAIN" | translate }}</h3>
    <label [for]="currentDomain.name">{{ "DOMAIN" | translate }}<sup class="text-danger">*</sup></label>
    <input name="currentDomainName" [(ngModel)]="currentDomain.name" type="text" [id]="currentDomain.name" class="form-control" />
    <div class="font-error" *ngIf="showModalError && (!currentDomain.name || currentDomain.name.length < 1)">{{ "ERRORS.FIELD_DOMAIN" | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="editDomain()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
